module.exports = __webpack_public_path__ + "static/media/intro-desktop-zh-HK.5822cd94.png";